/* Tri-tennis logo-configurator: live preview in wit, positie kiezen, vectorbestand uploaden of later aanleveren */
(function () {
  var VECTOR = /\.(eps|ai|pdf|svg)$/i;
  function whiteLogo(img, invert) {
    var max = 900, s = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
    var w = Math.max(1, Math.round(img.naturalWidth * s)), h = Math.max(1, Math.round(img.naturalHeight * s));
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d'); x.drawImage(img, 0, 0, w, h);
    var d = x.getImageData(0, 0, w, h), px = d.data, n = px.length, transparent = 0;
    for (var i = 3; i < n; i += 40) if (px[i] < 200) transparent++;
    var useAlpha = transparent > (n / 40) * 0.05;
    var minX = w, minY = h, maxX = -1, maxY = -1;
    for (var p = 0; p < n; p += 4) {
      var lum = (0.299 * px[p] + 0.587 * px[p + 1] + 0.114 * px[p + 2]) / 255, a;
      if (useAlpha) {
        a = px[p + 3];
        if (invert) a = Math.round(a * lum);
      } else {
        var ink = invert ? lum : 1 - lum;
        a = Math.round(Math.max(0, Math.min(1, (ink - 0.12) / 0.45)) * 255);
      }
      px[p] = px[p + 1] = px[p + 2] = 255; px[p + 3] = a;
      if (a > 24) { var k = p / 4, yy = Math.floor(k / w), xx = k - yy * w; if (xx < minX) minX = xx; if (xx > maxX) maxX = xx; if (yy < minY) minY = yy; if (yy > maxY) maxY = yy; }
    }
    x.putImageData(d, 0, 0);
    if (maxX < 0) return c.toDataURL('image/png');
    var cw = maxX - minX + 1, ch = maxY - minY + 1, o = document.createElement('canvas'); o.width = cw; o.height = ch;
    o.getContext('2d').drawImage(c, minX, minY, cw, ch, 0, 0, cw, ch);
    return o.toDataURL('image/png');
  }
  function init(root) {
    if (root.__ttlc) return; root.__ttlc = true;
    var form = root.querySelector('[data-lc-form]');
    var pFile = root.querySelector('[data-lc-preview-file]'), drop = root.querySelector('[data-lc-drop]'), dropLabel = root.querySelector('[data-lc-drop-label]');
    var invert = root.querySelector('[data-lc-invert]'), logos = root.querySelectorAll('[data-lc-logo]'), hint = root.querySelector('[data-lc-hint]');
    var posInput = root.querySelector('[data-lc-pos-input]'), delInput = root.querySelector('[data-lc-delivery-input]');
    var vWrap = root.querySelector('[data-lc-vector-wrap]'), vFile = root.querySelector('[data-lc-vector-file]'), vLabel = root.querySelector('[data-lc-vector-label]');
    var err = root.querySelector('[data-lc-err]'), btn = root.querySelector('[data-lc-submit]'), email = root.getAttribute('data-email');
    var srcImg = null;

    function render() {
      if (!srcImg) return;
      var url = whiteLogo(srcImg, invert.checked);
      logos.forEach(function (l) { l.src = url; l.hidden = false; });
    }
    function loadPreview() {
      var f = pFile.files && pFile.files[0]; if (!f) return;
      if (!/^image\/(jpeg|png)$/.test(f.type)) { showErr('Please choose a JPG or PNG file for the preview.'); pFile.value = ''; return; }
      var r = new FileReader();
      r.onload = function () { var im = new Image(); im.onload = function () { srcImg = im; render(); drop.classList.add('has-file'); dropLabel.textContent = f.name; if (hint && !root.getAttribute('data-pos')) hint.textContent = 'Now choose option 1 (top) or option 2 (middle).'; check(); }; im.src = r.result; };
      r.readAsDataURL(f);
    }
    pFile.addEventListener('change', loadPreview);
    ['dragenter', 'dragover'].forEach(function (e) { drop.addEventListener(e, function () { drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (e) { drop.addEventListener(e, function () { drop.classList.remove('is-over'); }); });
    invert.addEventListener('change', render);

    var skip = root.querySelector('[data-lc-skip]'), skipInput = root.querySelector('[data-lc-skip-input]'), invWrap = root.querySelector('[data-lc-invert-wrap]');
    if (skip) skip.addEventListener('change', function () {
      var on = skip.checked;
      drop.style.display = on ? 'none' : '';
      if (invWrap) invWrap.style.display = on ? 'none' : '';
      if (on) {
        pFile.value = ''; pFile.disabled = true; srcImg = null;
        logos.forEach(function (l) { l.hidden = true; l.removeAttribute('src'); });
        drop.classList.remove('has-file'); dropLabel.textContent = 'Choose a JPG or PNG logo';
        skipInput.value = 'No preview – logo file will follow';
        if (hint) hint.textContent = 'No preview needed – just choose the position where your logo will be printed.';
        if (!root.querySelector('[data-lc-delivery]:checked')) { var later = root.querySelector('[data-lc-delivery][value="later"]'); if (later) { later.checked = true; later.dispatchEvent(new Event('change')); } }
      } else {
        pFile.disabled = false; skipInput.value = '';
        if (hint) hint.textContent = 'Upload your logo to see it on both positions, then choose option 1 or 2.';
      }
      check();
    });

    root.querySelectorAll('[data-lc-pos]').forEach(function (b) {
      b.addEventListener('click', function () {
        root.setAttribute('data-pos', b.getAttribute('data-lc-pos'));
        posInput.value = b.getAttribute('data-value');
        root.querySelectorAll('[data-lc-pos]').forEach(function (o) { var on = o === b; o.classList.toggle('is-active', on); o.setAttribute('aria-checked', on ? 'true' : 'false'); });
        if (hint) hint.textContent = b.getAttribute('data-value').replace(/^Option \d – /, 'Your logo: ');
        check();
      });
    });

    root.querySelectorAll('[data-lc-delivery]').forEach(function (r) {
      r.addEventListener('change', function () {
        var now = r.value === 'now' && r.checked;
        vWrap.hidden = !now;
        if (!now) { vFile.value = ''; vWrap.classList.remove('has-file'); vLabel.textContent = 'Choose your EPS, AI, PDF or SVG file'; vFile.disabled = true; } else { vFile.disabled = false; }
        delInput.value = now ? 'Uploaded with order' : 'Will be sent later by email to ' + email;
        check();
      });
    });
    vFile.disabled = true;
    vFile.addEventListener('change', function () {
      var f = vFile.files && vFile.files[0];
      if (f && !VECTOR.test(f.name)) { showErr('Please upload a vector file: EPS, AI, PDF or SVG (no JPG or PNG).'); vFile.value = ''; vWrap.classList.remove('has-file'); vLabel.textContent = 'Choose your EPS, AI, PDF or SVG file'; check(); return; }
      if (f) { vWrap.classList.add('has-file'); vLabel.textContent = f.name; }
      check();
    });

    root.querySelectorAll('[data-lc-q]').forEach(function (b) {
      b.addEventListener('click', function () { var q = form.querySelector('[name="quantity"]'); q.value = Math.max(1, Math.min(99, (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-lc-q'), 10))); });
    });

    function problems() {
      var out = [];
      if (!posInput.value) out.push('choose logo position 1 or 2');
      var d = root.querySelector('[data-lc-delivery]:checked');
      if (!d) out.push('choose whether you upload your vector logo now or send it later');
      else if (d.value === 'now' && !(vFile.files && vFile.files[0])) out.push('upload your EPS, AI, PDF or SVG file');
      return out;
    }
    function showErr(t) { err.textContent = t; err.hidden = false; }
    function check() { var p = problems(); btn.classList.toggle('is-locked', p.length > 0); if (!p.length) err.hidden = true; return p; }
    form.addEventListener('submit', function (e) {
      var p = check();
      if (p.length) { e.preventDefault(); showErr('Please ' + p.join(' and ') + '.'); return; }
      if (!(pFile.files && pFile.files[0])) pFile.disabled = true;
      if (skipInput && !skipInput.value) skipInput.disabled = true;
      if (vFile.disabled || !(vFile.files && vFile.files[0])) vFile.disabled = true;
      btn.disabled = true; btn.style.opacity = '.6';
    });
    check();
  }
  function boot() { document.querySelectorAll('[data-tt-lc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();